import CancelButton from "../../../components/buttons/backButton/CancelButton";
import ProceedButton from "../../../components/buttons/proceedButton/ProceedButton";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import { useProgression } from "../../../hooks/useProgression";

interface BaseContentProps {
  screenName: string;
  disableNext: boolean;
  proceedButtonText?: string;
  customProceedButton?: JSX.Element;
  saveProgress: () => void;
}

const BaseContent = (props: React.PropsWithChildren<BaseContentProps>) => {
  const { goNext } = useProgression();
  const {
    screenName,

    disableNext,
    proceedButtonText,
    customProceedButton,
    saveProgress,
    children,
  } = props;

  const onProceed = () => {
    saveProgress();
    goNext();
  };

  return (
    <>
      <ProgressBar disableNext={disableNext} saveProgress={saveProgress} />
      <div className="progress-content mt-20" data-testid={screenName}>
        {children}
        <div>
          <div className="page-content-button-container-button-full-width">
            {customProceedButton ? (
              customProceedButton
            ) : (
              <ProceedButton
                onProceed={onProceed}
                disabled={disableNext}
                variant="contained"
                value={proceedButtonText}
              />
            )}
          </div>
          <div className="page-content-button-container">
            <div className="page-content-button-container-button-center">
              <CancelButton />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BaseContent;
